<template>
  <div class="app-container">
    <div class="table-box">
      <el-form
        :model="queryParams"
        ref="queryForm"
        size="small"
        :inline="true"
        v-show="showSearch"
        label-width="100px"
      >
        <el-form-item label="操作类别" prop="operatetype">
          <el-select
            v-model="queryParams.operatetype"
            placeholder="请选择操作类别"
            clearable
          >
            <el-option
              v-for="dict in operate_type"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleQuery"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
            >重置</el-button
          >
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="operateRecordList" max-height="680">
        <el-table-column label="序号" align="center" prop="id" />
        <el-table-column label="数据id" align="center" prop="dataid" />
        <el-table-column label="操作行为" align="center" prop="behavior" />
        <el-table-column
          label="操作时间"
          align="center"
          prop="time"
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作类别" align="center" prop="operatetype">
          <template slot-scope="scope">
            <div v-for="(dict, index) in operate_type" :key="index">
              <span v-if="dict.value == scope.row.operatetype">{{
                dict.label
              }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="备注" align="center" prop="remark" /> -->
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
    <!-- 添加或修改操作记录对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import pagination from "@/components/Pagination/index.vue";

export default {
  name: "OperateRecord",
  components: { pagination },
  data() {
    return {
      operate_type: [
        {
          label: "新增巡检记录",
          value: "insert_patrol",
        },
        {
          label: "新增巡检问题",
          value: "insert_issue",
        },
        {
          label: "巡检问题审核",
          value: "confirm_issue",
        },
        {
          label: "巡检问题解决",
          value: "solve_issue",
        },
      ],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 操作记录表格数据
      operateRecordList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        dataid: null,
        behavior: null,
        time: null,
        operatetype: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {},
      headers: {
        "Access-Token": this.$store.state.token,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询操作记录列表 */
    getList() {
      this.loading = true;
      Axios.get("/hzyApi/hwDocking/getOperateRecord", {
        params: this.queryParams,
        headers: this.headers,
      }).then((res) => {
        console.log("getOperateRecord=====", res);
        if (res.data.code == 200) {
          this.operateRecordList = res.data.rows;
          this.total = res.data.total;
        }
      });
      this.loading = false;
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        dataid: null,
        behavior: null,
        time: null,
        operatetype: null,
        remark: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
  },
};
</script>

<style scoped>
.table-box {
  height: 90vh;
  overflow: hidden;
}
</style>
